import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from '../../store/reducer';
import * as ArticlesActions from '../../store/actions';
import { Filter } from '../../models/filter.model';

@Component({
  selector: 'app-group-selected',
  templateUrl: './group-selected.component.html',
  styleUrls: ['./group-selected.component.scss']
})
export class GroupSelectedComponent implements OnInit {
  parent = { Name: '', Id: 0 };
  viewValue = { Name: '', Id: 0 };
  allGroups: any[] = [];

  private app = Filter.getAggregationAndId('app');
  @Input() isMobile: boolean;

  currentLevel = 0;

  constructor(
    private store: Store<State>,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.store.select('articles').subscribe((state: any) => {
      if (state.loadedArticles) {
        const agg = state.result.Aggregations.ArticleGroupAggregationItem;
        if (!state.togglingSidenav && agg.BaseItems.length !== 0) {
          this.currentLevel = agg.AggregationLevel;
          this.app = Filter.getAggregationAndId('app');

          const parentGroup = `Group${this.currentLevel - 1}`;
          const viewGroup = `Group${this.currentLevel}`;

          this.parent = Filter.getValue(parentGroup);
          this.viewValue = Filter.getValue(viewGroup);

          this.allGroups = agg.BaseItems.filter(item => item.Id !== this.viewValue.Id);

          this.store.dispatch({
            type: ArticlesActions.ActionTypes.CHANGE_FILTERS,
            payload: { filters: Filter }
          });
        }
      }
    });
  }

  navigateUp() {
    if (this.currentLevel < 3) {
      return;
    }

    const targetLevel = this.currentLevel - 1;
    const parentId = this.parent.Id;

    if (Filter.Query.length) {
      this.router.navigate(
        [Filter.Query.join(' '), this.app.lvl, this.app.id, targetLevel, parentId],
        { relativeTo: this.route.parent }
      );
    } else {
      this.router.navigate(
        [this.app.lvl, this.app.id, targetLevel, parentId],
        { relativeTo: this.route.parent }
      );
    }
  }

  navigateDown(item: any) {
    const targetLevel = this.currentLevel + 1;
    if (Filter.Query.length) {
      this.router.navigate(
        [Filter.Query.join(' '), this.app.lvl, this.app.id, targetLevel, item.Id],
        { relativeTo: this.route.parent }
      );
    } else {
      this.router.navigate(
        [this.app.lvl, this.app.id, targetLevel, item.Id],
        { relativeTo: this.route.parent }
      );
    }
  }
}
